"use strict";

module.exports = function parseWaxSealsPackage(transaction) {
  var matcher = transaction.title.match(/([a-z]*) Wax Seals/i);
  var color = matcher[1];
  var quantity;
  var pattern;
  transaction.product_data.property_values.forEach(function (_ref) {
    var property_name = _ref.property_name,
        values = _ref.values;

    if (property_name.match(/^quantity/i)) {
      quantity = parseInt(values[0], 10);
    }

    if (property_name.match(/pattern/i)) {
      pattern = values[0];
    }
  });
  var wax_seal_style = "".concat(color, " ").concat(pattern);
  this.waxSeals.add({
    quantity: quantity,
    wax_seal_style: wax_seal_style
  });
};